import { useMemo } from 'react';
import { isReactionsEnabled } from '../helpers/featureFlags';

export const useReactionsEnabled = (): boolean => useMemo(() => isReactionsEnabled(), []);

export default useReactionsEnabled;
